import type { ReactNode } from 'react';
import { Alert, AlertTitle, useTheme } from '@mui/material';

interface DefaultFallbackProps {
  fullscreen?: boolean;
  severity?: 'info' | 'error' | 'warning' | 'success';
  message?: string | undefined;
  // Optional trailing control (e.g. a Retry button) rendered in the Alert's action slot.
  action?: ReactNode;
}

const DefaultFallback = ({ message, fullscreen = false, severity = 'info', action }: DefaultFallbackProps) => {
  const theme = useTheme();

  if (fullscreen)
    return (
      <Alert
        severity={severity || undefined}
        action={action}
        sx={{
          borderTop: `1px solid ${severity ? theme?.palette?.[severity]?.main : theme?.palette?.utility?.main}`,
          borderBottom: `1px solid ${severity ? theme?.palette?.[severity]?.main : theme?.palette?.utility?.main}`,
          borderRadius: 0,
        }}
      >
        <AlertTitle>{message || `No data found.`}</AlertTitle>
      </Alert>
    );

  return (
    <Alert
      severity={severity}
      action={action}
      sx={{ border: `1px solid ${severity ? theme?.palette?.[severity]?.main : theme?.palette?.utility?.main}` }}
    >
      <AlertTitle>{message || `No data found.`}</AlertTitle>
    </Alert>
  );
};

export default DefaultFallback;
